/**
 * App State Detection Utility
 * Detects if app is in foreground or background
 */

export function getAppState() {
  if (typeof document === 'undefined') {
    return 'background';
  }
  
  if (document.hidden) {
    return 'background';
  }
  
  return 'foreground';
}

/**
 * Listen for app state changes (visibility API)
 * Returns cleanup function
 */
export function watchAppState(callback) {
  if (typeof document === 'undefined') {
    return () => {};
  }

  const handleVisibilityChange = () => {
    const state = getAppState();
    callback(state);
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);
  
  // Also check window focus/blur for Electron
  const handleFocus = () => {
    callback('foreground');
  };
  
  const handleBlur = () => {
    // Don't immediately set to background on blur
    // Only set if document is also hidden
    if (document.hidden) {
      callback('background');
    }
  };

  window.addEventListener('focus', handleFocus);
  window.addEventListener('blur', handleBlur);

  // Initial state
  callback(getAppState());

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('focus', handleFocus);
    window.removeEventListener('blur', handleBlur);
  };
}
